<style type="text/scss" lang="scss">
  @import '../../styles/vars';
</style>

<script>
  export let value = '';
  export let placeholder = '';
  export let label = '';
  export let readonly = false;
</script>

<div>
  {#if label}<label>{label}</label>{/if}
  <input
    type="number"
    on:input
    on:change
    readonly="{readonly}"
    bind:value="{value}"
    placeholder="{placeholder}"
  />
</div>
